import { ReactNode } from 'react'
import { useFormContext } from 'react-hook-form'
import { IconButton } from '@mui/material'

interface Props {
  name: string
  value: unknown
  children: ReactNode
}

const FormIconButton = ({ name, value, children }: Props) => {
  const { setValue } = useFormContext()

  return (
    <IconButton
      size="small"
      onClick={() => {
        setValue(name, value, { shouldDirty: true, shouldTouch: true })
      }}
      sx={{ color: 'inherit' }}
    >
      {children}
    </IconButton>
  )
}

export default FormIconButton
